import React from 'react';
import { PageLayout } from '../../components/shared/PageLayout';
import { Seo } from '../../components/shared/Seo';
import { HeroSection } from '../../components/shared/HeroSection';
import { FeatureGridSection } from '../../components/shared/FeatureGridSection';
import { AboutContentSection } from './components/AboutContentSection';
const AboutPage: React.FC = () => {
  const heroStats = [
    { value: '5000+', label: 'Happy Customers' },
    { value: '5+ Years', label: 'Experience' },
    { value: '100%', label: 'Satisfaction Guarantee' },
  ];

  const features = [
    { icon: 'ri-user-star-line', title: 'Certified Technicians', description: 'Our team consists of certified and experienced technicians who are experts in handling all types of electronic device repairs.' },
    { icon: 'ri-shield-check-line', title: 'Genuine Parts Only', description: 'We use only the best spare parts and tools for all repairs to ensure your device runs as good as new.' },
    { icon: 'ri-time-line', title: 'Same-Day Service', description: 'Fast and efficient repair services with most repairs completed within the same day for your convenience.' },
    { icon: 'ri-truck-line', title: 'Free Pickup & Delivery', description: 'We offer on-site repair services and free pick-up to make your experience as convenient as possible.' },
    { icon: 'ri-money-dollar-circle-line', title: 'Affordable Pricing', description: 'High-quality repairs at competitive prices with transparent pricing and no hidden costs.' },
    { icon: 'ri-customer-service-2-line', title: '100% Satisfaction Guarantee', description: 'We stand behind our work with a complete satisfaction guarantee on all our repair services.' }
  ];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "About Device Doctor - Mobile Repair Experts Kochi",
    "description": "Learn about Device Doctor's 10+ years of mobile repair experience in Kochi, Kerala",
    "url": "https://devicedoctor.in/about",
    "mainEntity": { "@type": "Organization", "name": "Device Doctor", "foundingDate": "2013", "description": "Professional mobile and laptop repair service center in Kochi with over 10 years of experience", "address": { "@type": "PostalAddress", "streetAddress": "Store no 1, Near Nakshatra Jewellery, Vyttila Jn", "addressLocality": "Kochi", "addressRegion": "Kerala", "postalCode": "682019", "addressCountry": "IN" }, "telephone": "+918714014140", "areaServed": "Kerala" }
  };

  return (
    <PageLayout>
      <Seo
        title="About Device Doctor Kochi - 10+ Years Mobile Repair Experience Kerala"
        description="Learn about Device Doctor Kochi - Kerala's trusted mobile repair experts with 10+ years experience. Professional team, genuine parts, and customer satisfaction guaranteed. Located at Vyttila Junction."
        keywords="about device doctor, mobile repair experience kochi, phone repair team kerala, trusted repair center vyttila, mobile service history"
        structuredData={structuredData}
      />
      <h1 style={{ position: 'absolute', left: '-9999px' }}>About Device Doctor - Mobile Repair Experts in Kochi, Kerala</h1>

      <HeroSection
        title="About Device Doctor"
        subtitle="Your trusted laptop and mobile repair service in Kochi, providing high-quality, affordable, and reliable repair solutions for all your electronic devices."
        badge={{ text: 'About Us', icon: 'ri-tools-line' }}
        stats={heroStats}
        className="bg-gradient-to-br from-red-600 to-red-800"
      />
      
      <AboutContentSection />
      
      <FeatureGridSection
        title="What Makes Device Doctor Special"
        subtitle="We're committed to providing the best repair experience in Kochi with our expert team, quality parts, and customer-first approach."
        badgeText="Why Choose Us"
        features={features}
        theme="alternative"
      />
      
    </PageLayout>
  );
};

export { AboutPage };
export default AboutPage;